import { Cinzel, Cormorant_Garamond, Great_Vibes, Montserrat } from "next/font/google"
import type { PlaqueFontFace } from "@/lib/plaqueDesign"

// Browser copies of the faces in PLAQUE_FONT_FACES (the production SVG route
// outlines the same families from Google's TTFs). Scoped to /plaque so the rest
// of the site doesn't pay for them.
const cinzel = Cinzel({ subsets: ["latin"], weight: ["600"], display: "swap" })
const cormorantItalic = Cormorant_Garamond({ subsets: ["latin"], weight: ["600"], style: "italic", display: "swap" })
const greatVibes = Great_Vibes({ subsets: ["latin"], weight: "400", display: "swap" })
const montserrat = Montserrat({ subsets: ["latin"], weight: ["500"], display: "swap" })

export interface PlaqueBrowserFont {
  fontFamily: string
  fontWeight: number
  fontStyle: "normal" | "italic"
}

export const PLAQUE_BROWSER_FONTS: Record<PlaqueFontFace, PlaqueBrowserFont> = {
  capitals: { fontFamily: cinzel.style.fontFamily, fontWeight: 600, fontStyle: "normal" },
  serifItalic: { fontFamily: cormorantItalic.style.fontFamily, fontWeight: 600, fontStyle: "italic" },
  script: { fontFamily: greatVibes.style.fontFamily, fontWeight: 400, fontStyle: "normal" },
  sans: { fontFamily: montserrat.style.fontFamily, fontWeight: 500, fontStyle: "normal" },
}

// Measure with a canvas at a large size and scale down, so the preview shrinks
// long lines the same way the production outline does.
let ctx: CanvasRenderingContext2D | null = null
export function measurePlaqueTextInBrowser(text: string, face: PlaqueFontFace, sizeMm: number): number {
  if (!ctx) ctx = document.createElement("canvas").getContext("2d")
  if (!ctx) return 0
  const f = PLAQUE_BROWSER_FONTS[face]
  ctx.font = `${f.fontStyle} ${f.fontWeight} 100px ${f.fontFamily}`
  return (ctx.measureText(text).width / 100) * sizeMm
}
